import React, { useContext } from 'react';
import { Field, Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import * as Yup from 'yup';
import { FormikCalendar } from '../../../../components/prime-formik';
import { UPDATE_DOCUMENT_SCHEDULED_ON_DATE_MUTATION } from '../services/document-management.service';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { growlActionSuccess, growlErrors } from '../../../../utils/NotificationUtil';
import { useMutation } from '@apollo/react-hooks';
import { computeEnforcedOnDate } from '../helpers/documents.helper';

const UpdateDocumentScheduledOnDialog = ({
  documentId,
  documentType,
  showUpdateDocumentScheduledOnDialog,
  hideUpdateDocumentScheduledOnDialog,
}) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [updateDocumentScheduledOn] = useMutation(UPDATE_DOCUMENT_SCHEDULED_ON_DATE_MUTATION);

  const updateScheduledOn = async ({ scheduledOn }) => {
    const scheduledOnInUTC = new Date(
      Date.UTC(scheduledOn.getFullYear(), scheduledOn.getMonth(), scheduledOn.getDate()),
    );

    try {
      await updateDocumentScheduledOn({
        variables: {
          input: {
            accountId: currentAccount,
            documentId,
            scheduledOn: scheduledOnInUTC,
          },
        },
        refetchQueries: ['documentListQuery'],
      });

      hideUpdateDocumentScheduledOnDialog();
      growlActionSuccess(growl);
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const initialValues = {
    scheduledOn: '',
  };

  const validationSchema = Yup.object().shape({
    scheduledOn: Yup.string().required(),
  });

  return (
    <Dialog
      header="Update document scheduled on date"
      visible={showUpdateDocumentScheduledOnDialog}
      onHide={hideUpdateDocumentScheduledOnDialog}
      style={{
        maxWidth: '25%',
      }}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => updateScheduledOn(values)}
      >
        {({ isValid, isSubmitting, values: { scheduledOn }, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className="p-col-12 center">
                <p>Select the date when the document is scheduled on:</p>
                <Field
                  name="scheduledOn"
                  id="scheduledOn"
                  component={FormikCalendar}
                  dateFormat="yy-M-dd"
                  minDate={new Date()}
                />

                {!!scheduledOn && (
                  <p>
                    Will be enforced on: <strong>{computeEnforcedOnDate(documentType, scheduledOn)}</strong>
                  </p>
                )}

                <br />
                <div className="align-center">
                  <Button
                    type="button"
                    className="p-button-secondary"
                    onClick={hideUpdateDocumentScheduledOnDialog}
                    disabled={isSubmitting}
                    label="Cancel"
                  />
                  <Button type="submit" disabled={!isValid || isSubmitting} label="Save" />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default UpdateDocumentScheduledOnDialog;
